/**
 * Libellés — espace Administration système.
 */

export const ADMIN_COPY = {
  TAGLINE: 'Plateforme de santé au travail',

  LAYOUT: {
    NAVBAR_BRAND: 'Administration système',
    TOPBAR_TAGLINE:
      'FUNTOA eHealth+ — pilotage global, données SMIE, rapports et paramètres',
    SIDE_MENU_SECTION: 'Console d’administration',
    ACCOUNT_FALLBACK: 'Compte'
  },

  NAV_SECTIONS: {
    overview: 'Vue d’ensemble',
    data: 'Données SMIE',
    reports: 'Rapports',
    system: 'Plateforme'
  },

  NAV: {
    dashboard: {
      label: 'Tableau de bord',
      hint: 'Synthèse et activité en direct',
      icon: 'home'
    },
    users: {
      label: 'Utilisateurs',
      hint: 'Comptes professionnels et rôles',
      icon: 'users'
    },
    companies: {
      label: 'Sociétés partenaires',
      hint: 'Entreprises adhérentes au SMIE',
      icon: 'building'
    },
    members: {
      label: 'Adhérents',
      hint: 'Agents, ayants-droit et import DNS',
      icon: 'user'
    },
    sites: {
      label: 'Sites médicaux',
      hint: 'Infirmeries et points de soin',
      icon: 'warehouse'
    },
    reportsReception: {
      label: 'Réception',
      hint: 'Passages et rendez-vous',
      icon: 'signIn'
    },
    reportsNursing: {
      label: 'Infirmerie',
      hint: 'Actes et stats major',
      icon: 'heart'
    },
    reportsClinical: {
      label: 'Médecin',
      hint: 'Statistiques cliniques',
      icon: 'stethoscope'
    },
    reportsPharmacy: {
      label: 'Pharmacie',
      hint: 'Dispensations et stocks',
      icon: 'pills'
    },
    pharmacyCentral: {
      label: 'Pharmacie centrale',
      hint: 'Catalogue, stocks, commandes',
      icon: 'warehouse'
    },
    settings: {
      label: 'Paramètres',
      hint: 'Configuration et sécurité',
      icon: 'cog'
    }
  },

  DASHBOARD: {
    BADGE: 'Administration',
    TITLE: 'Tableau de bord',
    SUBTITLE: 'Vue globale de la plateforme en temps réel.',
    REFRESH: 'Actualiser',
    ACTIVITIES_TITLE: 'Activités récentes',
    ACTIVITIES_EMPTY: 'Aucune activité récente.',
    ACTIVITIES_LOADING: 'Chargement des activités…',
    QUICK_ACTIONS_TITLE: 'Accès rapide',
    REPORTS_HUB_TITLE: 'Rapports institutionnels',
    REPORTS_HUB_HINT: 'Quatre domaines — même modèle que les espaces métier.',
    STAT_USERS: 'Utilisateurs',
    STAT_USERS_SUB: (n) => `${n} actifs`,
    STAT_COMPANIES: 'Sociétés',
    STAT_COMPANIES_SUB: (n) => `${n} actives`,
    STAT_MEMBERS: 'Adhérents',
    STAT_MEMBERS_SUB: (agents, conj, enf) =>
      `${agents} agents · ${conj} conjoints · ${enf} enfants`,
    STAT_SITES: 'Sites',
    STAT_SITES_SUB: (n) => `${n} actifs`,
    STAT_CONSULTATIONS: 'Consultations',
    STAT_CONSULTATIONS_SUB: (n) => `${n} aujourd’hui`,
    STAT_PENDING: 'Demandes pharmacie',
    STAT_PENDING_SUB: 'Approvisionnement en attente',
    QUICK_USERS: 'Utilisateurs',
    QUICK_COMPANIES: 'Sociétés',
    QUICK_MEMBERS: 'Adhérents',
    QUICK_SITES: 'Sites',
    QUICK_REPORTS: 'Rapports médicaux',
    QUICK_PHARMACY: 'Pharmacie centrale',
    NO_ACTIONS: 'Aucune action disponible pour votre profil.',
    TYPE_MEMBER: 'Adhérent',
    TYPE_COMPANY: 'Société',
    TYPE_USER: 'Utilisateur',
    TYPE_OTHER: 'Activité'
  },

  ARIA_TOGGLE_MENU: 'Ouvrir le menu de navigation',
  ARIA_CLOSE_MENU: 'Fermer le menu de navigation',
  ARIA_TOGGLE_SIDEBAR: 'Réduire le menu latéral',
  ARIA_EXPAND_SIDEBAR: 'Développer le menu latéral',
  SIDEBAR_COLLAPSE: 'Réduire',
  SIDEBAR_EXPAND: 'Développer',
  ARIA_USER_MENU: 'Menu du compte utilisateur',
  MOBILE_NAV_TITLE: 'Navigation',

  MEMBERS: {
    BADGE: 'Administration',
    PAGE_TITLE: 'Gestion des adhérents',
    PAGE_SUBTITLE:
      'Agents et ayants-droit par société · hiérarchie familiale · création manuelle ou import DNS.',
    TAB_LIST: 'Liste',
    TAB_ARCHIVES: 'Archives',
    TAB_IMPORT: 'Import DNS',
    TAB_DEBAUCHE_IMPORT: 'Débauche Excel',
    TAB_TEMPLATE: 'Télécharger le modèle DNS',
    SEARCH_PLACEHOLDER: 'Matricule, nom ou prénom…',
    TYPE_ALL: 'Tous les types',
    COMPANY_ALL: 'Toutes les sociétés',
    BTN_CREATE: 'Nouvel adhérent'
  },

  PLACEHOLDER: {
    settings: {
      title: 'Paramètres',
      description:
        'Configuration globale de la plateforme, politiques de sécurité et préférences — module en cours de déploiement.'
    }
  }
};
